<!--@keyup="$emit('update:data1', $event.target.value)"-->
<template>
    <div id="combinaison">

        <!--Color selector-->
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">

                <div class="itemMain">
                    <div class="itemSubTitle">s-colorSelector</div>
                    <div class="itemContain">
                        !!! À VÉRIFIER POUR LE RETOUR DE LA VALEUR !!!<br>
                        <s-colorSelector
                            :number.sync= "colorValue">
                        </s-colorSelector>
                        <br>Selected Value : {{colorValue}}<br> Content value : {{exComboFix[comboSelectorValue]}}
                    </div>
                </div>

            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <table style="width: 100%" border="1px">
                    <colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 30%;"><col span="1" style="width: 40%;"></colgroup>
                    <tr class="backRep"><td colspan="3">src\components\communs\s-colorSelector\s-colorSelector.vue</td></tr>
                    <tr class="backHead"><th>Propriété</th><th>Type</th><th>Description</th></tr>
                    <tr><td>number</td><td>number</td><td>Valeur de la couleur sélectionné</td></tr>
                </table>
            </b-col>
        </b-row>

        <!--comboFix-->
        <br>
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">

                <div class="itemMain">
                    <div class="itemSubTitle">s-comboFix</div>
                    <div class="itemContain">
                        <s-comboFix
                            v-if="exComboFix"
                            :content="exComboFix"
                            title="Exemple de titre"
                            name="comboFix1"
                            :value.sync= "comboFixValue">
                        </s-comboFix>

                        <br>disable = true<br>
                        <s-comboFix
                            v-if="exComboFix"
                            :content="exComboFix"
                            title="Exemple de titre"
                            name="comboFix1"
                            disable="true"
                            :value.sync= "comboFixValue">
                        </s-comboFix>

                        <br>Selected Value : {{comboFixValue}}<br> Content value : {{exComboFix[comboFixValue]}}
                    </div>
                </div>

            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <table style="width: 100%" border="1px">
                    <colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 30%;"><col span="1" style="width: 40%;"></colgroup>
                    <tr class="backRep"><td colspan="3">src\components\communs\s-comboFix\s-comboFix.vue</td></tr>
                    <tr class="backHead"><th>Propriété</th><th>Type</th><th>Description</th></tr>
                    <tr><td>v-if="content name"</td><td>content name</td><td>Mettre le nom de la variable content, permets d'éviter des erreurs si le content est à null</td></tr>
                    <tr><td>content</td><td>array object</td><td>Contenu du combo box<br>Ex. de content :<br>exComboFix:[<br>{id: 0, text: "nom 0",},<br>{id: 1, text: "nom 1",},<br>{id: 2, text: "nom 2",}<br>]<br><br>2e champs<br>text = affiche le text inscrit<br>lng = affiche selon la source du fichier de langue</td></tr>
                    <tr><td>disable</td><td>bool</td><td>Si à TRUE alors la composante n'est pas disponible</td></tr>
                    <tr><td>title</td><td>string</td><td>Titre affiché sur la composante</td></tr>
                    <tr><td>name</td><td>string</td><td>Nom de la composante</td></tr>
                    <tr><td>:value.sync</td><td>number</td><td>Liens vers la variable qui contiens la valeur sélectionnée</td></tr>
                </table>
            </b-col>
        </b-row>

        <!--combo Selector-->
        <br>
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">

                <div class="itemMain">
                    <div class="itemSubTitle">s-comboSelector</div>
                    <div class="itemContain">
                        <s-comboSelector
                            v-if="exComboFix"
                            class="txtPrincipal mPaie" 
                            showField="text" 
                            returnField="id" 
                            :content="exComboFix" 
                            name= "comboSelector" 
                            title="s-comboSelector" 
                            :value="comboSelectorValue" 
                            :returnValue.sync="comboSelectorValue" 
                            :selectedItems="comboSelectorValue">
                        </s-comboSelector>

                        <br>disable = true<br>
                        <s-comboSelector
                            v-if="exComboFix"
                            class="txtPrincipal mPaie" 
                            showField="text" 
                            returnField="id" 
                            :content="exComboFix" 
                            disable = "true"
                            name= "comboSelector" 
                            title="s-comboSelector" 
                            :value="comboSelectorValue" 
                            :returnValue.sync="comboSelectorValue" 
                            :selectedItems="comboSelectorValue">
                        </s-comboSelector>

                        <br>noNone = true<br>selectStatus = true<br>
                        <s-comboSelector
                            v-if="exComboFix"
                            class="txtPrincipal mPaie" 
                            showField="text" 
                            returnField="id" 
                            :content="exComboFix" 
                            noNone = "true"
                            selectStatus = "true"
                            name= "comboSelector" 
                            title="s-comboSelector" 
                            :value="comboSelectorValue" 
                            :returnValue.sync="comboSelectorValue" 
                            :selectedItems="comboSelectorValue">
                        </s-comboSelector>

                        <br>Selected Value : {{comboSelectorValue}}<br> Content value : {{exComboFix[comboSelectorValue]}}
                    </div>
                </div>

            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <table style="width: 100%" border="1px">
                    <colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 30%;"><col span="1" style="width: 40%;"></colgroup>
                    <tr class="backRep"><td colspan="3">src\components\communs\s-comboSelector\s-comboSelector.vue</td></tr>
                    <tr class="backHead"><th>Propriété</th><th>Type</th><th>Description</th></tr>
                    <tr><td>v-if="content name"</td><td>content name</td><td>Mettre le nom de la variable content, permets d'éviter des erreurs si le content est à null</td></tr>
                    <tr><td>content</td><td>array object</td><td>Contenu du combo box<br>Ex. de content :<br>exComboFix:[<br>{id: 0, text: "nom 0",},<br>{id: 1, text: "nom 1",},<br>{id: 2, text: "nom 2",}<br>]<br><br>2e champs<br>text = affiche le text inscrit<br>lng = affiche selon la source du fichier de langue</td></tr>
                    <tr><td>selectStatus</td><td>bool</td><td>Permet de mettre le contour du bouton en Vert / Rouge selon si la selection est obligatoire ou non</td></tr>
                    <tr><td>name</td><td>string</td><td>Nom de la composante</td></tr>
                    <tr><td>title</td><td>string</td><td>Titre affiché sur la composante</td></tr>
                    <tr><td>showField</td><td>string</td><td>Champs du content à afficher</td></tr>
                    <tr><td>returnField</td><td>string</td><td>Champs du content à retourner lors de la sélection <br></td></tr>
                    <tr><td>selectedItems</td><td>null</td><td>Valeur de l'item sélectionné</td></tr>
                    <tr><td>disable</td><td>bool</td><td>Si à TRUE alors la composante n'est pas disponible</td></tr>
                    <tr><td>noNone</td><td>bool</td><td>Si on enleve le choix AUCUN</td></tr>
                    <tr><td>baseZero</td><td>bool</td><td>Si la base est une base 0 ou une base 1 ou autre.... a TRUE c'est une base 1</td></tr>
                </table>
            </b-col>
        </b-row>

        <!--CURRENCY INPUT-->
        <br>
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">

                <div class="itemMain">
                    <div class="itemSubTitle">s-currencyInput</div>
                    <div class="itemContain">
                        <div style="width: 135px">
                            decimal = 2<br>
                            
                            <s-currencyInput
                                :Name="'debit' + index" 
                                decimal="2" 
                                v-model="currencyInputValue"
                                onKeyPress="zeroCredit">
                            </s-currencyInput>
                            <br>disabled = true :<br>decimal = 3<br>
                            <s-currencyInput
                                :Name="'debit' + index" 
                                decimal="3" 
                                :disabled="true" 
                                v-model="currencyInputValue">
                            </s-currencyInput>
                            <br>prepend $ / append % <br>
                            <s-currencyInput
                                :Name="'debit' + index" 
                                append="%" 
                                prepend="$" 
                                decimal="2" 
                                v-model="currencyInputValue">
                            </s-currencyInput>
                        </div>
                        <br>Value : {{currencyInputValue}}
                    </div>
                </div>

            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <table style="width: 100%" border="1px">
                    <colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 30%;"><col span="1" style="width: 40%;"></colgroup>
                    <tr class="backRep"><td colspan="3">src\components\communs\s-currencyInput\s-currencyInput.vue</td></tr>
                    <tr class="backHead"><th>Propriété</th><th>Type</th><th>Description</th></tr>
                    <tr><td>value</td><td>number</td><td>Valeur envoyé et retourné</td></tr>
                    <tr><td>append</td><td>string</td><td>Text à la fin de la composante</td></tr>
                    <tr><td>decimal</td><td>number</td><td>Nombre de chiffre après la virgule</td></tr>
                    <tr><td>name</td><td>string</td><td>Nom de la composante</td></tr>
                    <tr><td>min</td><td>number</td><td>Valeur minimal</td></tr>
                    <tr><td>max</td><td>number</td><td>Valeur maximal</td></tr>
                    <tr><td>prepend</td><td>number</td><td>Text au début de la composante</td></tr>
                    <tr><td>disabled</td><td>number</td><td>Si a true la composante n'est pas disponible</td></tr>
                    <tr><td>onkeyPress</td><td>string</td><td>Fonction à retourner au parent lors d'un keyPress event</td></tr>
                    <tr><td>valueKeyPress</td><td>string</td><td>Fonction à retourner au parent lors d'une valeur entrée</td></tr>
                    <tr><td>minus</td><td>bool</td><td>Affichage d'un bouton [-] pour réduire la valeur</td></tr>
                    <tr><td>plus</td><td>bool</td><td>Affichage d'un bouton [+] pour augmenter la valeur</td></tr>
                    <tr><td>valueChanged</td><td>string</td><td>Fonction à retourner au parent lors d'un changement de valeur</td></tr>
                    <tr><td>enteredValue</td><td>string</td><td>Valeur entrée dans la composante</td></tr>
                    <tr><td>onBlur</td><td>string</td><td>Fonction à retourner au parent lors d'une perte de focus</td></tr>
                </table>
            </b-col>
        </b-row>

        <!--DUO SELECTOR-->
        <br>
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">

                <div class="itemMain">
                    <div class="itemSubTitle">s-duoSelector</div>
                    <div class="itemContain">
                        <s-duoSelector
                            text1= "False"
                            text2= "True"
                            :value="duoSelectorValue" 
                            :returnValue.sync="duoSelectorValue">
                        </s-duoSelector>
                        <br>Selected Value : {{duoSelectorValue}}
                    </div>
                </div>

            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <table style="width: 100%" border="1px">
                    <colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 30%;"><col span="1" style="width: 40%;"></colgroup>
                    <tr class="backRep"><td colspan="3">src\components\communs\s-duoSelector\s-duoSelector.vue</td></tr>
                    <tr class="backHead"><th>Propriété</th><th>Type</th><th>Description</th></tr>
                    <tr><td>text1</td><td>string</td><td>Texte du bouton de gauche</td></tr>
                    <tr><td>text2</td><td>string</td><td>Texte du bouton de droite</td></tr>
                    <tr><td>value</td><td>bool</td><td>Valeur envoyé à la composante</td></tr>
                    <tr><td>:returnValue.sync</td><td>bool</td><td>Valeur reçu de la composante</td></tr>
                    <tr><td>invertTrueFalse</td><td>bool</td><td>Inverse la valeur FALSE sur le bouton de droite et TRUE à gauche</td></tr>
                </table>
            </b-col>
        </b-row>

        <!--LANGUE SELECTOR-->
        <br>
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">

                <div class="itemMain">
                    <div class="itemSubTitle">s-langueSelector</div>
                    <div class="itemContain">
                        <s-langueSelector
                            :value.sync="langueSelectorValue">
                        </s-langueSelector>
                        <br>Selected Value : {{langueSelectorValue}}
                    </div>
                </div>

            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <table style="width: 100%" border="1px">
                    <colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 30%;"><col span="1" style="width: 40%;"></colgroup>
                    <tr class="backRep"><td colspan="3">src\components\communs\s-langueSelector\s-langueSelector.vue</td></tr>
                    <tr class="backHead"><th>Propriété</th><th>Type</th><th>Description</th></tr>
                    <tr><td>text1</td><td>string</td><td>Texte du bouton de gauche</td></tr>
                    <tr><td>text2</td><td>string</td><td>Texte du bouton de droite</td></tr>
                    <tr><td>value</td><td>bool</td><td>Valeur envoyé à la composante</td></tr>
                    <tr><td>:returnValue.sync</td><td>bool</td><td>Valeur reçu de la composante</td></tr>
                    <tr><td>invertTrueFalse</td><td>bool</td><td>Inverse la valeur FALSE sur le bouton de droite et TRUE à gauche</td></tr>
                </table>
            </b-col>
        </b-row>

        <!--LINE-->
        <br>
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">

                <div class="itemMain">
                    <div class="itemSubTitle">s-line</div>
                    <div class="itemContain">
                        <s-line></s-line>
                    </div>
                </div>

            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <table style="width: 100%" border="1px">
                    <colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 30%;"><col span="1" style="width: 40%;"></colgroup>
                    <tr class="backRep"><td colspan="3">src\components\communs\s-line\s-line.vue</td></tr>
                    <tr class="backHead"><th>Propriété</th><th>Type</th><th>Description</th></tr>
                    
                </table>
            </b-col>
        </b-row>

        <!--TABS-->
        <br>
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">

                <div class="itemMain">
                    <div class="itemSubTitle">s-tabs</div>
                    <div class="itemContain">
                        <s-tabs
                            :tabList= "exTabs"
                            :value.sync= "tabsValue">
                        </s-tabs>
                        <br>Selected Value : {{tabsValue}}
                    </div>
                </div>

            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <table style="width: 100%" border="1px">
                    <colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 30%;"><col span="1" style="width: 40%;"></colgroup>
                    <tr class="backRep"><td colspan="3">src\components\communs\s-tabs\s-tabs.vue</td></tr>
                    <tr class="backHead"><th>Propriété</th><th>Type</th><th>Description</th></tr>
                    <tr><td>tabList</td><td>array object</td><td>Object :<br>.id=0<br>.name=""</td></tr>
                    <tr><td>:value.sync</td><td>number</td><td>Valeur retourné : correspond à l'id de tabList</td></tr>
                </table>
            </b-col>
        </b-row>

        <!--upDownArrow-->
        <br>
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">

                <div class="itemMain">
                    <div class="itemSubTitle">s-upDownArrow</div>
                    <div class="itemContain">
                        NOTE : Doit être placé à l'intérieur d'une composante. Ex. un bouton.<br>Affiche seulement l'icone haut et bas selon le status.<br>

                        <b-button class="btnMode MargeTop5" type="button" :variant="getTheme.warning" @mousedown="upDownArrowValue = !upDownArrowValue">
                            <s-upDownArrow :status="upDownArrowValue">
                            </s-upDownArrow>
                        </b-button>
                        <br><br>Selected Value : {{upDownArrowValue}}
                    </div>
                </div>

            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <table style="width: 100%" border="1px">
                    <colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 30%;"><col span="1" style="width: 40%;"></colgroup>
                    <tr class="backRep"><td colspan="3">src\components\communs\s-upDownArrow\s-upDownArrow.vue</td></tr>
                    <tr class="backHead"><th>Propriété</th><th>Type</th><th>Description</th></tr>
                    <tr><td>status</td><td>bool</td><td>Status de l'objet. False = Bas, True = haut</td></tr>
                </table>
            </b-col>
        </b-row>

        <!--datePicker-->
        <br>
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">

                <div class="itemMain">
                    <div class="itemSubTitle">s-datePicker</div>
                    <div class="itemContain">
                        disabled = false<br>
                        <s-datePicker
                            :dateValue.sync= "dateTimeValue"
                            name="dateTime">
                        </s-datePicker>
                        <br>disabled = true<br>
                        <s-datePicker
                            :dateValue.sync= "dateTimeValue"
                            name="dateTime"
                            disabled="true">
                        </s-datePicker>
                        <br><br>Selected Value : {{dateTimeValue}}
                    </div>
                </div>

            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <table style="width: 100%" border="1px">
                    <colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 30%;"><col span="1" style="width: 40%;"></colgroup>
                    <tr class="backRep"><td colspan="3">src\components\servex\s-datePicker\s-datePicker.vue</td></tr>
                    <tr class="backHead"><th>Propriété</th><th>Type</th><th>Description</th></tr>
                    <tr><td>:dateValue.sync</td><td>date</td><td>Date retourné</td></tr>
                    <tr><td>name</td><td>string</td><td>Nom de la composante</td></tr>
                    <tr><td>min</td><td>date</td><td>Date minimal</td></tr>
                    <tr><td>max</td><td>date</td><td>Date maximal</td></tr>
                    <tr><td>disabled</td><td>bool</td><td>Si a True alors la composante est non disponible</td></tr>
                </table>
            </b-col>
        </b-row>

        <!--input-->
        <br>
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">

                <div class="itemMain">
                    <div class="itemSubTitle">s-input</div>
                    <div class="itemContain">
                        <s-input
                            v-model="textInputValue">
                        </s-input>
                        <br><br>Selected Value : {{textInputValue}}
                    </div>
                </div>

            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <table style="width: 100%" border="1px">
                    <colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 30%;"><col span="1" style="width: 40%;"></colgroup>
                    <tr class="backRep"><td colspan="3">src\components\servex\s-input\s-input.vue</td></tr>
                    <tr class="backHead"><th>Propriété</th><th>Type</th><th>Description</th></tr>
                    <tr><td>v-model</td><td>date</td><td>Liens à la variable du texte</td></tr>
                    <tr><td>myClass</td><td>string</td><td>Nom de la class à utiliser</td></tr>
                    <tr><td>id</td><td>date</td><td>id du champs texte</td></tr>
                    <tr><td>name</td><td>date</td><td>Nom de la composante</td></tr>
                    <tr><td>autocomplete</td><td>bool</td><td>Si à False, le champs ne conservera pas en mémoire les valeur précédente</td></tr>
                    <tr><td>type</td><td>bool</td><td>Si texte, numeric ou autre</td></tr>
                    <tr><td>maxlength</td><td>bool</td><td>Nombre maximal de charactère</td></tr>
                    <tr><td>placeholder</td><td>bool</td><td>Texte fantôme à afficher lorsque le champs est vide</td></tr>
                </table>
            </b-col>
        </b-row>


        <!--monthSelector-->
        <!--<br>
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">

                <div class="itemMain">
                    <div class="itemSubTitle">s-monthSelector</div>
                    <div class="itemContain">
                        <s-monthSelector
                            v-model="monthSelectorValue"
                            title="s-monthSelector">
                        </s-monthSelector>
                        <br><br>Selected Value : {{monthSelectorValue}}
                    </div>
                </div>

            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <table style="width: 100%" border="1px">
                    <colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 30%;"><col span="1" style="width: 40%;"></colgroup>
                    <tr class="backRep"><td colspan="3">src\components\servex\s-input\s-input.vue</td></tr>
                    <tr class="backHead"><th>Propriété</th><th>Type</th><th>Description</th></tr>
                    <tr><td>v-model</td><td>date</td><td>Liens à la variable du texte</td></tr>
                    <tr><td>myClass</td><td>string</td><td>Nom de la class à utiliser</td></tr>
                    <tr><td>id</td><td>date</td><td>id du champs texte</td></tr>
                    <tr><td>name</td><td>date</td><td>Nom de la composante</td></tr>
                    <tr><td>autocomplete</td><td>bool</td><td>Si à False, le champs ne conservera pas en mémoire les valeur précédente</td></tr>
                    <tr><td>type</td><td>bool</td><td>Si texte, numeric ou autre</td></tr>
                    <tr><td>maxlength</td><td>bool</td><td>Nombre maximal de charactère</td></tr>
                    <tr><td>placeholder</td><td>bool</td><td>Texte fantôme à afficher lorsque le champs est vide</td></tr>
                </table>
            </b-col>
        </b-row>-->



    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 'combinaison',
    components: {
},
    props: ['leftSize', 'deptList', 'DNumber'],
    data() {
        return {
            collaps: false,
            collaps2: false,
            comboFixValue: 0,
            comboSelectorValue: 0,
            currencyInputValue: 1,
            upDownArrowValue: false,
            colorValue: 0,
            monthSelector: 1,
            tabsValue: 0,
            textInputValue: 'example de texte',
            duoSelectorValue: true,
            langueSelectorValue: 1,
            dateTimeValue: "",
            exComboFix:[
                {id: 0, text: "nom 0",},
                {id: 1, text: "nom 1",},
                {id: 2, text: "nom 2",}
            ],
            exComboSelector:[
                {id: 0, text: "nom 0",},
                {id: 1, text: "nom 1",},
                {id: 2, text: "nom 2",}
            ],
            exTabs:[
                {id: 0, name: "nom 0",},
                {id: 1, name: "nom 1",},
                {id: 2, name: "nom 2",}
            ]

        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme']),
        _DNumber: {
            get: function() {return this.DNumber},
            set: function(modifiedValue){this.$emit('update:DNumber', modifiedValue)}
        }
    }
}
</script>

<style lang="scss" scoped>
.backRep{
    background: $cContainerLeftBorder;
}
.backHead{
    background: $ServexGray;
    color: $ServexWhite;
}
</style>